import { Link } from "react-router-dom";

/**
 * Public deletion request page — no auth required.
 * Required by Google Play (since 2024) and India DPDP guidance for any
 * app that collects personal data. Explains what is deleted and how.
 */
export default function DeleteAccountPublic() {
  return (
    <div className="min-h-screen" style={{ background: "var(--canvas, #F4F3F1)" }} data-testid="delete-account-public">
      <div className="max-w-2xl mx-auto px-4 py-10">
        <h1 style={{ fontFamily: "Barlow Condensed, sans-serif", fontWeight: 700, fontSize: 32 }}>
          Delete your FitFrik account
        </h1>
        <p style={{ marginTop: 12, fontSize: 14, color: "#4A4845", lineHeight: 1.6 }}>
          You can permanently delete your FitFrik account and personal data at any time.
          Follow one of the two options below.
        </p>

        <section style={{ marginTop: 24 }}>
          <h2 style={{ fontFamily: "Barlow Condensed, sans-serif", fontWeight: 700, fontSize: 20 }}>
            Option 1 — Delete from the app
          </h2>
          <ol style={{ fontSize: 14, color: "#4A4845", lineHeight: 1.7, marginLeft: 20, marginTop: 8 }}>
            <li>Sign in to FitFrik.</li>
            <li>Go to <Link to="/settings" style={{ color: "#00D4FF" }}>Settings</Link>.</li>
            <li>Tap <em>Delete account</em>, type DELETE to confirm.</li>
          </ol>
        </section>

        <section style={{ marginTop: 20 }}>
          <h2 style={{ fontFamily: "Barlow Condensed, sans-serif", fontWeight: 700, fontSize: 20 }}>
            Option 2 — Email us
          </h2>
          <p style={{ fontSize: 14, color: "#4A4845", lineHeight: 1.6, marginTop: 8 }}>
            Write to <a href="mailto:support@fitfrik.com?subject=Delete%20my%20account" style={{ color: "#00D4FF" }}>support@fitfrik.com</a>
            {" "}from the email address on your account. We reply within 3 business days.
          </p>
        </section>

        <section style={{ marginTop: 24 }}>
          <h2 style={{ fontFamily: "Barlow Condensed, sans-serif", fontWeight: 700, fontSize: 20 }}>
            What is deleted
          </h2>
          <ul style={{ fontSize: 14, color: "#4A4845", lineHeight: 1.7, marginLeft: 20, marginTop: 8 }}>
            <li>Your name, email, avatar and profile details.</li>
            <li>Your body stats, workout history, food logs, hydration and morning check-ins.</li>
            <li>Your posts, comments, tips and community activity.</li>
            <li>Your saved trainers, bookings and inbox threads.</li>
            <li>Your FitPoints ledger and cached balance.</li>
          </ul>
        </section>

        <section style={{ marginTop: 20 }}>
          <h2 style={{ fontFamily: "Barlow Condensed, sans-serif", fontWeight: 700, fontSize: 20 }}>
            What we keep
          </h2>
          <p style={{ fontSize: 14, color: "#4A4845", lineHeight: 1.6, marginTop: 8 }}>
            We retain aggregated, anonymised usage data (never linked to you) and any records
            we are legally required to keep — for example, payment records for tax purposes,
            for the period required under Indian law.
          </p>
        </section>

        <section style={{ marginTop: 20 }}>
          <h2 style={{ fontFamily: "Barlow Condensed, sans-serif", fontWeight: 700, fontSize: 20 }}>
            Grace period
          </h2>
          <p style={{ fontSize: 14, color: "#4A4845", lineHeight: 1.6, marginTop: 8 }}>
            After you confirm deletion your account is disabled immediately.
            You have <strong>30 days</strong> to reactivate by signing in again.
            After 30 days your data is permanently purged.
          </p>
        </section>

        <div style={{ marginTop: 32, fontSize: 12, color: "#8E8A84" }}>
          Questions? <a href="mailto:support@fitfrik.com" style={{ color: "#00D4FF" }}>support@fitfrik.com</a>
        </div>
      </div>
    </div>
  );
}
